import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Mujeres de 40+ diagnosticadas (o que sospechan de TDAH) que sienten que su dinero se escapa entre los dedos.', 'Profesionales que ganan bien pero siempre están en "modo emergencia" financiera.', 'Madres que gestionan la logística de toda una familia y ya no tienen espacio mental para sus propias cuentas.', 'Mujeres que sienten una parálisis visceral cada vez que tienen que revisar su estado de cuenta.'];
  const notForWho = ['Personas que buscan consejos de inversión, trading o criptomonedas.', 'Alguien que ya tiene un sistema de organización financiera perfecto y automatizado.', 'Personas que no están dispuestas a dedicar 15 minutos iniciales para configurar sus alertas móviles.'];
  return <section className="py-24 bg-white" data-id="element-169">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-170">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-171">
          {/* Para ti si... */}
          <FadeIn direction="right" data-id="element-172">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-teal mb-8 font-serif" data-id="element-173">
              Para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-174">
              {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-175">
                  <div className="flex-shrink-0 mt-1" data-id="element-176">
                    <CheckIcon className="w-6 h-6 text-brand-gold" data-id="element-177" />
                  </div>
                  <p className="ml-4 text-lg text-brand-charcoal/80" data-id="element-178">{item}</p>
                </li>)}
            </ul>
          </FadeIn>

          {/* No es para ti si... */}
          <FadeIn direction="left" delay={0.2} data-id="element-179">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-gray mb-8 font-serif" data-id="element-180">
              No es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-181">
              {notForWho.map((item, index) => <li key={index} className="flex items-start opacity-70" data-id="element-182">
                  <div className="flex-shrink-0 mt-1" data-id="element-183">
                    <XIcon className="w-6 h-6 text-brand-gray" data-id="element-184" />
                  </div>
                  <p className="ml-4 text-lg text-brand-gray" data-id="element-185">{item}</p>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}